import React from 'react';
import { motion } from 'framer-motion';
import type { Tone } from '../types/snak';
interface PillButtonProps {
  children: React.ReactNode;
  onClick: () => void;
  tone?: Tone;
  variant?: 'solid' | 'outline';
  full?: boolean;
}
export function PillButton({
  children,
  onClick,
  tone = 'light',
  variant = 'solid',
  full = false
}: PillButtonProps) {
  const solid = tone === 'dark' ? 'bg-primary text-background hover:brightness-105' : 'bg-background text-white hover:bg-[#02463b]';
  const outline = tone === 'dark' ? 'bg-transparent text-white/90 border border-white/25 hover:border-white/50' : 'bg-transparent text-background border border-[rgba(1,51,43,0.25)] hover:border-[rgba(1,51,43,0.6)]';
  return <motion.button type="button" onClick={onClick} whileHover={{
    y: -1
  }} whileTap={{
    scale: 0.97
  }} transition={{
    type: 'spring',
    stiffness: 500,
    damping: 30
  }} className={['inline-flex items-center justify-center gap-2 rounded-full px-6 py-3.5', 'font-body text-[15px] font-medium tracking-[-0.01em]', 'focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2', tone === 'dark' ? 'focus-visible:ring-offset-background' : 'focus-visible:ring-offset-white', variant === 'solid' ? solid : outline, full ? 'w-full' : ''].join(' ')} data-id="element-100" data-mp="jibqxnxieg3i">
      {children}
    </motion.button>;
}